var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTeamActivityWidgetIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F4D4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 17.0063C19.2149 23.6654 28.7861 23.6638 29 17.0062C28.7885 10.3305 19.2105 10.332 19 17.0063Z",
    stroke: "#7A31CE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M7 17.5044C7.15045 22.1658 13.8502 22.1647 14 17.5043C13.852 12.8313 7.14736 12.8324 7 17.5044Z",
    fill: "#7A31CE",
    stroke: "#7A31CE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M41 17.5044C40.8495 22.1658 34.1498 22.1647 34 17.5043C34.148 12.8313 40.8526 12.8324 41 17.5044Z",
    fill: "#7A31CE",
    stroke: "#7A31CE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0084 34.5C15.0507 33.554 14.8779 31.6493 15.2062 30.7405C17.55 22.9785 32.8733 24.1683 32.9998 32.1371L32.9998 34.5",
    stroke: "#7A31CE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M4.14905 28.0759C5.39402 23.6359 11.7095 22.9618 15 25.3816",
    stroke: "#7A31CE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M43.851 28.0759C42.606 23.6359 36.2905 22.9618 33 25.3816",
    stroke: "#7A31CE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTeamActivityWidgetIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/team-activity-widget-icon.9b3b0c29ba56877ebb917c621ae57303.svg";